import { Component, OnInit, OnDestroy } from '@angular/core';
import { Globals } from './globals';
import { Observable, of, Subject } from 'rxjs';
// import { TranslateService } from '@ngx-translate/core';
import { ApplicationSettingsService } from './api/services/application-settings.service';
import { environment } from '@environments/environment';
import { CF2_CONFIG } from '@core/tokens/cf2-config.token';
import { NavigationStateService } from '@core/services/navigation-state.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionStatus, SilentRequest } from '@azure/msal-browser';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ConsentScopes } from '@core/factories/cf2-msal.factory';
import { TranslocoService } from '@jsverse/transloco';
import { NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from "@angular/router";
import { CalendarPreviousViewDirective, CalendarTodayDirective, CalendarNextViewDirective, CalendarMonthViewComponent, CalendarWeekViewComponent, CalendarDayViewComponent, CalendarDatePipe, DateAdapter, provideCalendar } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

const PRODUCTION = environment.production;

@Component({
  selector: 'wcg-app',
  template: `
    <!-- <app-navigation> -->
    <router-outlet></router-outlet>
    <!-- </app-navigation> -->

    <!--    <div style="background: red; color: white; padding: 20px;">
          <h1>🚀 MAIN APP COMPONENT IS WORKING!</h1>
          <p>This should show regardless of routing issues</p>
        </div>-->
    @if (accessDenied) {
      <h6>Access Denied</h6>
    }
  `,
  standalone: false,
  providers: [ApplicationSettingsService, {provide: CF2_CONFIG, useExisting: CF2_CONFIG},
    provideCalendar({
      provide: DateAdapter,
      useFactory: adapterFactory,
    })],
})
export class AppComponent implements OnInit, OnDestroy {
  public accessDenied = false;

  private production = PRODUCTION;
  private unsubscribe = new Subject<void>();
  adUser: AccountInfo;

  constructor(private globals: Globals,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private navStateSvc: NavigationStateService,
    private transloco: TranslocoService,
    public router: Router
  ) {
    // Add routing debugging
    console.log('🔍 Current URL:', window.location.href);
    console.log('🔍 Router URL:', this.router.url);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        console.log('🚀 Navigation started to:', event.url);
      } else if (event instanceof NavigationEnd) {
        console.log('✅ Navigation completed to:', event.url);
      } else if (event instanceof NavigationError) {
        console.error('❌ Navigation error:', event.error);
      }
    });
  }

  async ngOnInit() {
    document.addEventListener('DOMNodeInserted', function() {
      const elements = document.querySelectorAll('[aria-owns]');

      elements.forEach(element => {
        element.removeAttribute('aria-owns');
      });
    });

    let language = "";
    const ci = localStorage.getItem("LangPref");
    if(ci !== undefined && ci !== null ){
      language = ci;
    } else {
      language = navigator.language.substring(0,2);
    }
    this.transloco.setActiveLang(language);

    this.navStateSvc.init(this.transloco);

    this.msalService.instance.handleRedirectPromise().then(res => {
      if (res?.account) {
        this.msalService.instance.setActiveAccount(res.account);
      }
    })
    this.init();

    this.navStateSvc.isLoggedIn = true;
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  private init() {
    console.log('🔧 init() method called');

    // Debug MSAL interaction status
    this.msalBroadcastService.inProgress$.subscribe(status => {
      console.log('🔧 MSAL interaction status:', status);
    });

    this.msalBroadcastService.inProgress$
        .pipe(
            filter((status: InteractionStatus) => {
              console.log('🔧 Filtering MSAL status:', status, 'Is None?', status === InteractionStatus.None);
              return status === InteractionStatus.None;
            }),
            takeUntil(this.unsubscribe)
        ).subscribe({
      next: (status) => {
        console.log('🔧 MSAL interaction status changed to None, proceeding with getDetails()');

        this.getDetails().subscribe({
          next: (account) => {
            console.log('✅ Authentication successful, account:', account);
          },
          error: (error) => {
            console.error('❌ Authentication failed, redirecting to login:', error);
            this.msalService.instance.loginRedirect();
          }
        })
      }
    })
  }


  private getDetails(): Observable<AccountInfo> {
    const account = this.msalService.instance.getActiveAccount();
    if (account) return of(account);
    const accessTokenRequest = {
      scopes: ConsentScopes,
      account: account
    } as SilentRequest;

    return this.msalService.acquireTokenSilent(accessTokenRequest)
      .pipe(map(data => data.account));
  }

  login() {
    // not implemented
  }


}
